import { NarrativeCreateButton } from '../NarrativeCreateButton';
import { getNarrativeCommunityTitle } from './utils';
import { NarrativeCommunityBreadcrumbs } from '../NarrativeCommunityBreadcrumbs';

type Props = {
  primaryIndustryLabel: string | undefined | null;
  primaryIndustrySlug: string | undefined | null;
  companyNameSlug: string | undefined | null;
  exchangeTicker: string | undefined | null;
  market: string | undefined | null;
  companyName: string | undefined | null;
  companyId: string | undefined | null;
  isLoading: boolean;
};

export const NarrativeCommunityHeader = ({
  primaryIndustryLabel,
  primaryIndustrySlug,
  companyNameSlug,
  exchangeTicker,
  market,
  companyName,
  companyId,
  isLoading,
}: Props) => {
  const title = getNarrativeCommunityTitle({
    companyName,
    primaryIndustryLabel,
    market,
  });
  return (
    <div className="grid grid-rows-[max-content_max-content] gap-x1  text-solid">
      <NarrativeCommunityBreadcrumbs
        market={market}
        primaryIndustrySlug={primaryIndustrySlug}
        exchangeTicker={exchangeTicker}
        companyNameSlug={companyNameSlug}
        companyName={companyName}
      />
      <div className="grid grid-cols-[1fr_max-content] gap-x1 items-center">
        {isLoading ? (
          <div className="bones max-w-[300px] h-[30px]" />
        ) : (
          <h1 className="text-xl font-bold m-0">{title}</h1>
        )}

        <NarrativeCreateButton companyId={companyId} />
      </div>
    </div>
  );
};
